import datePicker from './date-picker';

export default {
    datePicker,
};
